// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__9MB_z","head":"ProcedureTableInfo_head__2dS94"};